import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

interface JobOpeningProps {
    title: string;
    location: string;
    type: string;
    description: string;
    onApply: () => void;
}

const JobOpening: React.FC<JobOpeningProps> = ({ title, location, type, description, onApply }) => (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 transition-all hover:shadow-xl">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center">
            <h3 className="text-xl font-bold text-gray-900">{title}</h3>
            <div className="mt-2 sm:mt-0 flex-shrink-0">
                <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 mr-2">{location}</span>
                <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">{type}</span>
            </div>
        </div>
        <p className="mt-4 text-gray-600">{description}</p>
        <div className="mt-6 text-right">
            <Button onClick={onApply} variant="primary">
                Aplicar Ahora
            </Button>
        </div>
    </div>
);


export const JobsModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
    const handleApplyClick = (jobTitle: string) => {
        onClose();
        onOpenContactModal(`Aplicación para el puesto: ${jobTitle}`);
    };

    const handleSpontaneousApplication = () => {
        onClose();
        onOpenContactModal('Candidatura espontánea');
    }

    const jobOpenings = [
        {
            title: "Abogado/a Especialista en Tráfico",
            location: "Andorra / Remoto",
            type: "Jornada Completa",
            description: "Buscamos un abogado/a con experiencia en derecho administrativo sancionador y contencioso para unirse a nuestro equipo legal. Serás responsable de la gestión integral de expedientes de multas.",
        },
        {
            title: "Perito Reconstructor de Accidentes",
            location: "Madrid, España",
            type: "Colaborador",
            description: "Necesitamos peritos titulados y con experiencia en la reconstrucción de accidentes para colaborar en casos complejos. Se requiere capacidad de análisis y defensa del informe en juicio.",
        },
        {
            title: "Agente de Atención al Cliente (Multilingüe)",
            location: "Remoto",
            type: "Jornada Completa",
            description: "Únete a nuestro equipo de soporte para ser el primer punto de contacto con nuestros clientes. Imprescindible dominio de Español e Inglés. Se valorarán otros idiomas como Francés o Alemán.",
        },
    ];

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Trabaja con Nosotros">
       <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-gray-800">Únete a nuestro equipo</h3>
            <p className="mt-3 text-lg text-gray-600">
               Estamos en constante crecimiento y buscamos talento apasionado por la defensa de los derechos de los conductores en Europa.
            </p>
        </div>
        <div className="space-y-8">
            {jobOpenings.map((job, index) => (
                <JobOpening key={index} {...job} onApply={() => handleApplyClick(job.title)} />
            ))}
        </div>
        <div className="mt-12 bg-gray-50 p-6 rounded-lg text-center">
            <h4 className="text-lg font-bold text-gray-800">¿No ves una oferta para ti?</h4>
            <p className="mt-2 text-gray-600">Siempre estamos abiertos a conocer gente con talento. Envíanos tu candidatura espontánea y la tendremos en cuenta para futuras posiciones.</p>
            <div className="mt-4">
                <Button onClick={handleSpontaneousApplication} variant="secondary" size="medium">
                    Enviar CV
                </Button>
            </div>
        </div>
    </ModalBase>
  );
};
